export default __webpack_public_path__ + "static/media/quarter.4a28cc0c.svg";